<div class="tm-cnt-ext" >
    <div class="tm-cnt" [ngClass]="{'tm-cnt-mobile' : isMobile}">
        <div class="tm-cnt-title">
            <div class="tm-ico-cnt">
                <i class="fal fa-mouse-pointer tm-icon"></i>
            </div>
            <span class="te-title">{{modalTitle}}</span>
        </div>
        <div class="tm-cnt-body">
         <!-- BODY -->
            <teiasoft-grid style="width:100%"
                [title]="'nps-modal'"
                [columnsToHide]="columnsToHide"
                [columnsToShow]="columnsToShow"
                [dataSet]="dataSet"
                [showFooter]="false"
                [selectable]="false"
                [theme]="theme"
                (rowClick)="rowClick($event)"
                [minWidthVw]="50"
                [filterable]="true"
                [selectedRow]="selectedRow"
                [disableAllSelection]="false"
                [columnsToFilter]="columnsToFilter"
                (closeModal)="onConfirmModalClick()"
                [minWidthVw]="60"
                ></teiasoft-grid>
                <!-- GBR 05/03/2024 MQBF-22 Added (closeModal) -->
        </div>
        <div class="tm-cnt-btn" [ngClass]="{'tm-cnt-btn-mobile' : isMobile}">
            <teiasoft-button *ngIf="selectedRow && selectedRow.npsScheduleId && showDeleteSelection" (onClick)="onDeleteSelection()" class="mr-5" [text]="'commons.deleteSelection' | translate" [type]="'tb-primary'"  
                [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onConfirmModalClick()" class="mr-5" [text]="'commons.confirm' | translate" [type]="'tb-secondary'"  [theme]="theme" [isMobile]="isMobile" [disabled]="!canConfirmSelection()"></teiasoft-button>
            <teiasoft-button (onClick)="onCloseModalClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>
